import { render, staticRenderFns } from "./navbar-card.vue?vue&type=template&id=6b2f82d8&scoped=true&"
import script from "./navbar-card.vue?vue&type=script&lang=js&"
export * from "./navbar-card.vue?vue&type=script&lang=js&"
import style0 from "./navbar-card.vue?vue&type=style&index=0&id=6b2f82d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f82d8",
  null
  
)

export default component.exports